/*
 * Nordbjærg's menu keyboard fixes (UI audit 2, 21 Oct). The theme's own menus stay in charge;
 * this only adds what was missing:
 * - Esc closes an open desktop dropdown / mega menu and returns focus to its menu item
 *   (WCAG 1.4.13: content shown on hover or focus can be dismissed). The theme opens a dropdown
 *   when its item gets focus, so that one focus is not passed on to the theme.
 * - Esc closes the phone menu.
 * - "Tilbage" in the phone menu returns focus to the item that opened the panel (it fell to <body>).
 * - On Nordbjærg's katalog the menu bar is folded away; "Menu" in the header unfolds it (Esc or a click
 *   elsewhere folds it again).
 */
(function () {
  if (window.nbNavReady) return;
  window.nbNavReady = true;

  var skipFocus = null;

  // Swallow the one focus event we cause ourselves, so the theme doesn't reopen the dropdown
  document.addEventListener('focusin', function (event) {
    if (skipFocus && event.target === skipFocus) {
      event.stopImmediatePropagation();
      skipFocus = null;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var open = document.querySelectorAll('.header .is-dropdown-open');
    if (open.length) {
      var top = open[0];
      var trigger = top.querySelector('[data-type="menuitem"][aria-haspopup]');
      Array.prototype.forEach.call(open, function (item) {
        item.classList.remove('is-dropdown-open');
        var itemTrigger = item.querySelector('[data-type="menuitem"]');
        if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
        var panel = item.querySelector('[aria-hidden]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
        var menu = item.closest('[data-type="menu"]');
        if (menu) menu.classList.remove('nav-dropdown--glued');
      });
      if (trigger && document.activeElement !== trigger) {
        skipFocus = trigger;
        trigger.focus();
      }
      event.preventDefault();
      return;
    }

    var mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false') {
      var toggle = document.querySelector('.header__mobile-nav-toggle[aria-expanded="true"]');
      if (toggle) {
        toggle.click();
        toggle.focus();
        event.preventDefault();
      }
    }
  });

  // Katalog: "Menu" unfolds the menu bar under the header
  var menuToggle = document.querySelector('[data-nb-menu-toggle]');
  if (menuToggle) {
    var setMenu = function (open) {
      document.body.classList.toggle('nb-nav-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    menuToggle.addEventListener('click', function () { setMenu(!document.body.classList.contains('nb-nav-open')); });
    document.addEventListener('click', function (event) {
      if (document.body.classList.contains('nb-nav-open') && !event.target.closest('#nb-nav-bar, [data-nb-menu-toggle]')) setMenu(false);
    });
    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && document.body.classList.contains('nb-nav-open') && !document.querySelector('.header .is-dropdown-open')) {
        setMenu(false);
        menuToggle.focus();
      }
    });
  }

  // Phone menu "Tilbage": focus goes back to the item that opened the panel
  document.addEventListener('click', function (event) {
    var back = event.target.closest && event.target.closest('#mobile-menu [data-action="close-panel"]');
    if (!back) return;
    var panel = back.closest('.mobile-menu__panel');
    if (!panel || !panel.id) return;
    var opener = document.querySelector('#mobile-menu [aria-controls="' + panel.id + '"]');
    if (opener) window.setTimeout(function () { opener.focus({ preventScroll: true }); }, 0);
  });
})();
